import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ActionButton} from "../../../model/ui/action-button";
import {SelectItem} from "primeng/api";
import {AuthGuard} from "../../../common/auth-guard.service";
import {SortOrder} from "../../../model/sort-order";
import {DefaultDeviceCatalog} from "../../../model/default-device-catalog";
import {DefaultDeviceCatalogFilters} from "../../../model/filters/default-device-catalog-filters";
import {HwCatalogService} from "../../../services/hw-catalog.service";
import {DefaultAssetRepresentationsService} from "../../../services/default-asset-representations.service";
import {DefaultDeviceCategoriesService} from "../../../services/default-device-categories.service";
import {DefaultAssetRepresentation} from "../../../model/default-asset-representation";
import {DefaultDeviceCategory} from "../../../model/default-device-category";

@Component({
  selector: 'app-default-device-selector',
  templateUrl: './default-device-selector.component.html',
  styleUrls: ['./default-device-selector.component.scss']
})
export class DefaultDeviceSelectorComponent {

  readonly DEFAULT_SORT_FIELD = 'name';
  readonly DEFAULT_SORT_ORDER = 1;

  @Input() actionButtons: ActionButton[];

  @Output() visibleChange: EventEmitter<boolean>;

  dialogVisible: boolean;
  defaultDevices: DefaultDeviceCatalog[];
  totalDefaultDevices: number;
  loadingDefaultDevices: boolean;

  first: number;
  rows: number;

  defaultDeviceCategories: SelectItem<string>[];
  defaultAssetRepresentations: SelectItem<string>[];

  currentFilters: DefaultDeviceCatalogFilters;
  selectedDefaultDevice: DefaultDeviceCatalog;

  hasBeenOpened: boolean;

  constructor(private hwCatalogService: HwCatalogService,
              private defaultDeviceCategoriesService: DefaultDeviceCategoriesService,
              private defaultAssetRepresentationsService: DefaultAssetRepresentationsService,
              public authGuard: AuthGuard) {
    this.visibleChange = new EventEmitter<boolean>();
    this.first = 0;
    this.rows = 10;
    this.currentFilters = new DefaultDeviceCatalogFilters();
    this.currentFilters.sortField = this.DEFAULT_SORT_FIELD;
    this.currentFilters.sortOrder = this.DEFAULT_SORT_ORDER;
    this.loadingDefaultDevices = false;
    this.hasBeenOpened = false;
    this.defaultDevices = new Array(this.rows);
  }

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
    if (visible && !this.hasBeenOpened) {
      this.hasBeenOpened = true;
      this.loadDefaultDevices(0, this.rows);
      this.loadDefaultDeviceCategories();
      this.loadDefaultAssetRepresentations();
    }
  }

  applyFilters(): void {
    this.first = 0;
    this.loadDefaultDevices(this.first / this.rows, this.rows);
  }

  onPageChange(event: any): void {
    if (this.hasBeenOpened) {
      this.currentFilters.sortField = event.sortField;
      this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
      this.loadDefaultDevices(event.first / event.rows, event.rows);
    }
  }

  private loadDefaultDevices(offset: number, limit: number): void {
    this.loadingDefaultDevices = true;
    this.currentFilters.active = true;
    this.hwCatalogService.getDefaultDevicesCatalog(offset, limit, this.currentFilters).subscribe(response => {
      this.defaultDevices = response.defaultDevicesCatalog;
      this.totalDefaultDevices = response.totalElements;
      this.loadingDefaultDevices = false;
    });
  }

  private loadDefaultDeviceCategories(): void {
    this.defaultDeviceCategoriesService.getDefaultDeviceCategories().subscribe(response => {
      const categoryNames: string[] = response.defaultDeviceCategories
        .map((category: DefaultDeviceCategory) => category.name);
      const uniqueCategoryNames = [...new Set(categoryNames)];
      this.defaultDeviceCategories = uniqueCategoryNames.sort()
        .map((value: string) => ({value}));
    });
  }

  private loadDefaultAssetRepresentations(): void {
    this.defaultAssetRepresentationsService.getDefaultAssetRepresentations().subscribe(response => {
      const representationNames: string[] = response.defaultAssetRepresentations
        .map((representation: DefaultAssetRepresentation) => representation.name);
      const uniqueRepresentationNames = [...new Set(representationNames)];
      this.defaultAssetRepresentations = uniqueRepresentationNames.sort()
        .map((value: string) => ({value}));
    });
  }

}
